import { render, staticRenderFns } from "./author-icon.vue?vue&type=template&id=02713624&scoped=true&"
import script from "./author-icon.vue?vue&type=script&lang=js&"
export * from "./author-icon.vue?vue&type=script&lang=js&"
import style0 from "./author-icon.vue?vue&type=style&index=0&id=02713624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02713624",
  null
  
)

export default component.exports